<template>
	<div class="" @click="$sidebar.displaySidebar(false)">			
		<div class="row ">
            <div class="col-xl-8 mb-5 mb-xl-0">
                <div class="card shadow">
                    <div class="card-body">
						<h3 class="mb-3">下書き一覧</h3>
						<div class="loading"  v-show="loading">受信中...</div>
						<div class="el-table__body-wrapper table-responsive">
							<table class='table table-striped el-table__body' v-if="!loading">
								<thead>
									<tr class="el-table__row">
										<th scope="col">ID</th>
										<th scope="col">タイトル</th>
										<th scope="col">遷移先URL</th>
										<th scope="col">メッセージ本文</th>
										<th scope="col">&nbsp;</th>
									
									</tr>
								</thead>
								<tbody>
									<tr  v-for="notification in notificationList.data" :key="notification.id" class="el-table__row">
										<td class="el-table_1_column_1"> {{ notification.id }} </td>
										<td class="el-table_1_column_2"><p>{{ notification.title }}</p></td>
										<td class="el-table_1_column_3"> {{ notification.url }} </td>
										<td class="el-table_1_column_4 n-msg" width="500px"><p>{{ notification.message }} </p></td>
										<td class="el-table_1_column_5"><a :href="'/notifications/'+ siteId + '/edit'+'/' + notification.id" >詳細</a></td>
									</tr>
								</tbody>
							</table>
						</div>	
					</div>
                </div>
            </div>
			<div class="pagination-wrap">
			<pagination align="center" :data="notificationList" :show-disabled="true" :limit=5  @pagination-change-page="getResults">
				<span slot="prev-nav">&lt;</span>
				<span slot="next-nav">&gt;</span>
			</pagination>
			</div>
		</div>
	</div>
</template>

<script>
import pagination from 'laravel-vue-pagination'

export default {
    components: { pagination},
   
	data() {
		return {
			// Our data object that holds the Laravel paginator data
			notificationList: {},
			lastpage: null,
			siteId:null
			
		}
	},

	mounted() {
		// Fetch initial results
		this.siteId = window.PushL.site_id;
		this.getResults();
	},

	methods: {
		// Our method to GET results from a Laravel endpoint
		getResults(page = 1) {
			if(this.lastpage != null && this.lastpage < page) return;
			axios.get('/notifications/'+this.siteId+'/draftlist?page=' + page)
				.then(response => {
					this.notificationList = response.data;
					this.lastpage = response.data.last_page
				});
		},
        nl2br(text) {
			console.log("aaaa")
			return text.replace(/\n/g, "<br>")
		}

	}

}
</script>

<style scoped>

</style>